








































































import Vue from 'vue';
import Component from 'vue-class-component';
import { email, required } from 'vuelidate/lib/validators';
import { mapGetters, mapState, mapMutations } from 'vuex';
import FormInput from '@/components/ui/FormInput.vue';
import Customer from '@/models/Customer';

interface ActivateCustomerRequest {
	location: string;
	email: string;
}

const Setup = Vue.extend({
	name: 'ActivateCustomerForm',
	components: {
		FormInput,
	},
	props: {
		classes: [Array, Object, String],
		idPrefix: String,
		title: String,
		registerText: {
			type: String,
			default: 'Sign Up',
		},
		type: {
			type: String,
			default: 'login-only',
		},
		value: {
			type: Object,
		},
	},
	computed: {
		...mapState(['isLoading', 'paths']),
		...mapGetters('location', ['location']),
	},
	methods: {
		...mapMutations(['setLoggedIn', 'setLoading']),
	},
	validations: {
		email: { email, required },
	},
});

@Component
export default class ActivateCustomer extends Setup {
	// Props
	public classes!: string;
	public idPrefix!: string;
	public title!: string;
	public type!: string;
	public registerText!: string;
	public value!: { email: string; location: string };

	// Data
	public email: string = '';
	public code: string = '';
	public localErrors: any = {};
	public message: string = '';
	public error_message: string = '';

	// State
	public isLoading!: boolean;
	public paths!: any;

	// Getters
	public location!: Locations.Location;

	public get model(): ActivateCustomerRequest {
		return {
			email: this.email,
			location: this.location.codeID || '',
		};
	}

	public async submit() {
		this.$v.$touch();
		this.localErrors = {};

		if (this.$v.$invalid) {
			return;
		}

		this.$store.dispatch('googleEvents/activateCustomer', {
			email: this.model.email,
			location: this.model.location,
		});

		try {
			const response = await Customer.activateAccount(this.model.email, this.code, this.model.location);
			this.setLoggedIn(new Customer(response));
			this.setLoading(false);
			this.$emit('login', response);
			this.message = 'Account activated';
		} catch ({ response }) {
			this.error_message = 'Invalid email or activation code.';
			if (Array.isArray(response.data.errors)) {
				response.data.errors.forEach((error: any) => {
					if (error.name) {
						this.$set(this.localErrors, error.name, error.text);
					} else {
						this.$set(this.localErrors, 'page', error.text);
					}
				});
			}
		}
	}

	public async sendCode() {
		if (this.model.email) {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'sendActivationCode',
				fromInfo: '',
			});
			const response = await Customer.resendActivationCode(this.model.email, this.model.location);
			this.message = 'If an account exists, an email will be sent with a new activation code.';
		} else {
			this.error_message = 'Email is required to resend activation code.';
		}
	}
}
